export enum CustomDateInterval {
  Past24Hours = 'past_24_hours',
  LastWeek = 'last_week',
  LastMonth = 'last_month',
  LastYear = 'last_year',
}
